
import React from "react";

interface LegatiaCoordinationProps {
  coordinationText: string;
}

const LegatiaCoordination = ({ coordinationText }: LegatiaCoordinationProps) => {
  return (
    <div className="relative max-w-md mx-auto">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-legatia-light/50 via-white to-legatia-yellow/20 rounded-3xl transform rotate-1 opacity-60"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-legatia-yellow/10 via-white to-legatia-light/40 rounded-3xl transform -rotate-1 opacity-60"></div>
      
      {/* Main content */}
      <div className="relative text-center bg-gradient-to-r from-legatia-light/60 via-white/90 to-legatia-yellow/15 rounded-3xl p-8 md:p-10 border border-legatia-orange/20 shadow-xl hover:shadow-2xl transition-all duration-500 backdrop-blur-sm">
        <div className="relative flex justify-center items-center mb-6">
          {/* Logo glow effect */}
          <div className="absolute inset-0 w-28 h-28 md:w-32 md:h-32 bg-gradient-to-br from-legatia-orange/20 to-legatia-yellow/20 rounded-3xl blur-xl opacity-50"></div>
          
          {/* Logo container */}
          <div className="relative w-28 h-28 md:w-32 md:h-32 bg-gradient-to-br from-legatia-orange/10 via-white/50 to-legatia-yellow/10 rounded-3xl flex items-center justify-center shadow-2xl border-2 border-legatia-orange/10 group hover:scale-110 transition-all duration-500 hover:shadow-3xl overflow-hidden">
            {/* Shimmer effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -skew-x-12 -translate-x-full group-hover:translate-x-full transition-transform duration-1000"></div>
            
            {/* Inner glow */}
            <div className="absolute inset-3 bg-gradient-to-br from-legatia-orange/5 to-legatia-yellow/5 rounded-2xl"></div>
            
            <img 
              src="/lovable-uploads/a0bd0107-6fbe-4b1c-a269-1fb1c681f618.png" 
              alt="Legatia Logo" 
              className="relative w-18 h-18 md:w-22 md:h-22 object-contain filter drop-shadow-lg group-hover:drop-shadow-xl transition-all duration-300 z-10"
            />
          </div>
        </div>
        
        <span className="text-lg md:text-xl font-medium text-gray-800 block tracking-wide leading-relaxed">{coordinationText}</span>
        
        {/* Decorative elements */}
        <div className="absolute top-4 right-4 w-2 h-2 bg-legatia-orange/30 rounded-full animate-pulse"></div>
        <div className="absolute bottom-4 left-4 w-1.5 h-1.5 bg-legatia-yellow/40 rounded-full animate-pulse" style={{ animationDelay: "1s" }}></div>
      </div>
    </div>
  );
};

export default LegatiaCoordination;
